import { mockEmbeddedPartnersQueryData } from 'bundles/enterprise-learning-path-description-page/data/mockEmbeddedPartnersQuery';

export const useEmbeddedPartnersData = (enableXdpV2: boolean) => {
  if (!enableXdpV2) {
    return { data: null, isLoading: false, isError: false };
  }
  return { data: mockEmbeddedPartnersQueryData, isLoading: false, isError: false };
};
